import { PAGE_SCHEME } from '@/utils/enums/pageSchemes'

const SCHEMA_CONTEXT = 'https://schema.org'

const dropEmptyValues = (key, value) =>
  value === '' || value === null || value === undefined ? undefined : value

const serializeSchema = schemeObject =>
  JSON.stringify(schemeObject, dropEmptyValues).replace(/</g, '\\u003c')

export const generatePageScheme = schemes => {
  if (!schemes || !schemes.length) {
    /**
     * Removing schemas added by parent pages
     */
    return {
      script: [
        {
          hid: 'page-schemas',
          innerHTML: null
        }
      ]
    }
  }

  const nodes = schemes.map(({ type, data }) => PAGE_SCHEME[type](data || {}))

  const schemeObject =
    nodes.length === 1
      ? { '@context': SCHEMA_CONTEXT, ...nodes[0] }
      : { '@context': SCHEMA_CONTEXT, '@graph': nodes }

  return {
    script: [
      {
        hid: 'page-schemas',
        innerHTML: serializeSchema(schemeObject),
        type: 'application/ld+json'
      }
    ]
  }
}
